import { render, staticRenderFns } from "./UsefulArticles.vue?vue&type=template&id=ea469b34&"
import script from "./UsefulArticles.vue?vue&type=script&lang=ts&"
export * from "./UsefulArticles.vue?vue&type=script&lang=ts&"
import style0 from "./UsefulArticles.vue?vue&type=style&index=0&id=ea469b34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports